

export class Dispatch {
    states: {};
    listeners: {};

    constructor() {
        this.states = {};
        this.listeners = {};
    }

    public setState(tag: string, value: string, parent=null):void {

        if(value === 'toggle') {
            if(this.states[tag] === 'reveal') {
                value = null;
            } else {
                value = 'reveal';
            }
        }

        this.states[tag] = value;
        const listeners = this.listeners[tag] as Array<any>;
        listeners.forEach(listener => {
            if (parent === null) {
                listener.onChange(this.states[tag]);
            } else if (parent && parent.element.contains(listener.element)) {
                listener.onChange(this.states[tag]);
            }
        });
    }

    public getState(tag: string): string {
        return this.states[tag] || '';
    }

    public registerListener(tag: string, cb: any) {

        this.listeners[tag] = this.listeners[tag] || [];
        this.listeners[tag].push(cb);

    }

}
